var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 2a7 7 0 017 7 1 1 0 002 0 9 9 0 00-9-9 1 1 0 100 2zm8.75 11.91a1 1 0 00-.72-.65l-6-1.37a1 1 0 00-.92.26c-.14.13-.15.14-.8 1.38a9.91 9.91 0 01-4.87-4.89C8.21 8 8.22 8 8.35 7.85a1 1 0 00.26-.92L7.24 1a1 1 0 00-.65-.72A3.79 3.79 0 005.87.1 3.94 3.94 0 005.1 0 4.6 4.6 0 00.5 4.6 15.42 15.42 0 0015.9 20a4.6 4.6 0 004.6-4.6 4.338 4.338 0 00-.25-1.49zM15.9 18A13.41 13.41 0 012.5 4.6 2.61 2.61 0 015.1 2h.33L6.5 6.64l-.54.28c-.86.45-1.54.81-1.18 1.59a11.85 11.85 0 007.18 7.21c.84.34 1.17-.29 1.62-1.16l.29-.55 4.63 1.06v.33a2.61 2.61 0 01-2.6 2.6z",
    fill: "#828282"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.31409f83.svg";
export { ForwardRef as ReactComponent };